<template>
  <el-dialog
          width="60%"
          :title="!dataForm.id ? '新增' : '修改'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
             label-width="150px">
      <el-form-item label="名称" prop="name">
        <el-input clearable v-model="dataForm.name" ></el-input>
      </el-form-item>
      <el-form-item label="清单">
        <el-row>
          <el-form :model="form" ref="form" >
            <el-table :data="form.datils"  border style="width: 100%">


              <el-table-column  label="类型" width="250">
                <template slot="header" slot-scope="scope">
                  <el-row>
                    <el-col :span="4"><span>类型</span></el-col>
                    <el-col :span="20">
                      <el-input clearable placeholder="名称" @change="getTypes()" v-model="equipName" size="mini"></el-input>
                    </el-col>
                  </el-row>

                </template>
                <template slot-scope="scope">
                  <el-form-item :prop="'datils.'+scope.$index + '.id'" :rules='rules.name'>

                    <el-select filterable size="mini"  @change="((val)=>{changethisRow(val,scope.$index)})" v-model="scope.row.id" clearable placeholder="请选择">
                      <el-option

                              v-for="item in types"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>

              </el-table-column>
              <el-table-column  label="规格">
                <template slot-scope="scope">
                  {{scope.row.specification}}
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                  <el-form-item  :prop="'datils.'+scope.$index + '.num'" :rules='rules.num'>
                    <el-input  placeholder="数量" size="mini" v-model="scope.row.num" style="width: 100px;"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="operation" fixed="right">
                <template slot="header" slot-scope="scope">
                  <el-button size="mini" @click="click_add( scope.row, scope.$index)">新增</el-button>
                </template>
                <template slot-scope="scope">


                  <!--               <el-button size="mini" @click="click_reset(scope.row, scope.$index)">重置</el-button>-->
                  <el-button size="mini" @click="click_delete(scope.row, scope.$index)">删除</el-button>



                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-row>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
        var patrn = /^\d+(\.\d+)?$/;
        if (!patrn.exec(value)) {
          callback(new Error('请填写数字'))
        } else {
          callback()
        }
      }
      return {
        form: {
          datils: [

          ],

        },
        equipName:'',
        equips:[],
        //表单验证规则
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
            message: '请输入姓名',
          }],
          num: [{
            required: true,
            trigger: 'blur',
            message: '请输入数量',
          },{validator:validateNumber,trigger: 'blur'}],price: [{
            required: true,
            trigger: 'blur',
            message: '请输入单价',
          },{validator:validateNumber,trigger: 'blur'}],
        },
        loading:false,
        visible: false,
        useridList:[],
        menuList: [],
        customerList:[],
        dataForm: {
          id: '',
          name: '',

        },
        types: [],
        fileList:[],
        fileList2:[],
        currentPage: 1,
        total:0,
        uploadUrl:'',
        dataListSelections:[],
        dataRule: {
          name: [
            {required: true, message: '名称不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id
        this.visible = true
        this.$nextTick(() => {
          console.log('11111111111111111111')
          this.$refs['dataForm'].resetFields()
          this.useridList=[]
          this.equips=[]
          this.dataListSelections=[]
          this.equipName = ''
          this.getTypes();
          this.$refs['form'].resetFields()
          this.form.datils =  [

          ];
          if(this.dataForm.id) {
            this.$http({
              url: '/bjba/equip/config/info/'+this.dataForm.id,
              method: 'get'
            }).then(({data}) => {
              this.dataForm.id    = data.data.id
              this.dataForm.name  = data.data.name
              this.form.datils = data.data.detailIds
            })
          }

        })

      },
      changethisRow(config,index) {
        console.log(config,index)
        var newArr = this.types.filter(function (obj) {
          return obj.id== config;
        });
        var parse = JSON.parse(JSON.stringify(newArr));
        if(parse && parse.length>0)
          this.form.datils.splice(index,1,parse[0])
      },
      getTypes() {
        this.$request({
          method:'get',
          url:'/bjba/equip/type/getAll',
          params:{name:this.equipName}
        }).then(res => {

          this.types = res.data.data;
        })
      },

      //删除操作
      click_delete(item,index) {
        this.$confirm("确定删除该条数据吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
                .then(() => {
                  //模拟删除一条数据
                  this.form.datils.splice(index,1);
                })
                .catch(() => {});
      },
      //新增操作
      click_add(item,index) {
        // if( !this.validateField('form',index) ) return;
        //模拟新增一条数据
        var itemClone={
          id:'',
          num: ''
        }
        this.form.datils.push(itemClone);
        // this.resetField('form',index);
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
              // this.dataForm.datils =
            this.$refs['form'].validate((valid2) => {


              if(valid2){
                var data = {id:'',name:'',equipConfigDetails:[]};
                data.id = this.dataForm.id
                data.name = this.dataForm.name
                data.equipConfigDetails =this.form.datils.filter(function (obj) {
                  return  obj.num || obj.num!=0
                }).map(function (obj) {
                  var dataa = {id:'',num:''}
                  dataa.id = obj.id
                  dataa.num = obj.num
                  return dataa
                });

                if(!data.equipConfigDetails|| data.equipConfigDetails.length==0) {
                  this.$message({
                    message: '请选择装备',
                    type: 'error',
                    duration: 1500
                  })
                  return
                }
                this.$http({
                  url: '/bjba/equip/config/save',
                  method: 'post',
                  data: data
                }).then(({data}) => {
                  if (data && data.code === 200) {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 1500
                    })
                    this.visible = false
                    this.$emit('refreshDataList')
                  } else if(data && data.code === 500) {
                    this.$message({
                      message: data.message,
                      type: 'error',
                      duration: 1500
                    })
                  }
                })

              }
            })

          }
        })
      }
    }
  }
</script>
